/**
 * @param {string} configUrl
 * @returns {Promise<Object>}
 */
export async function fetchMediaConfig(configUrl) {
    const response = await fetch(configUrl, {method: 'GET'});

    if (!response.ok) {
        throw new Error(`Config request failed: ${response.status}`);
    }

    const json = await response.json();

    if (!json.success) {
        throw new Error(`Config error: ${json.data ?? 'Neznámá chyba'}`);
    }

    return json.data;
}
